
import React from 'react';

const FinanceDashboard = () => (
  <div className="p-0">
    {/* Charts */}
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
      <div className="bg-white rounded-lg shadow p-6">
        <div className="font-semibold mb-2">Revenue vs Expenses</div>
        <div className="h-48 flex items-center justify-center text-gray-400">[Line Chart]</div>
      </div>
      <div className="bg-white rounded-lg shadow p-6">
        <div className="font-semibold mb-2">Top Clients by Revenue</div>
        <div className="h-48 flex items-center justify-center text-gray-400">[Pie Chart]</div>
      </div>
    </div>
    {/* Tables */}
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <div className="bg-white rounded-lg shadow p-6">
        <div className="font-semibold mb-2">Recent Invoices</div>
        <table className="w-full text-sm">
          <thead>
            <tr className="text-gray-500 text-xs">
              <th className="py-2">Invoice No.</th>
              <th className="py-2">Client</th>
              <th className="py-2">Date</th>
              <th className="py-2">Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="py-2">INV-0001</td>
              <td className="py-2">Client A</td>
              <td className="py-2">2024-03-05</td>
              <td className="py-2">$2,500</td>
            </tr>
            <tr>
              <td className="py-2">INV-0002</td>
              <td className="py-2">Client B</td>
              <td className="py-2">2024-04-10</td>
              <td className="py-2">$3,000</td>
            </tr>
            <tr>
              <td className="py-2">INV-0003</td>
              <td className="py-2">Client C</td>
              <td className="py-2">2024-05-15</td>
              <td className="py-2">$4,000</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="bg-white rounded-lg shadow p-6">
        <div className="font-semibold mb-2">Recent Payments</div>
        <table className="w-full text-sm">
          <thead>
            <tr className="text-gray-500 text-xs">
              <th className="py-2">Payment No.</th>
              <th className="py-2">Client</th>
              <th className="py-2">Date</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="py-2">PAY-0001</td>
              <td className="py-2">Client A</td>
              <td className="py-2">2024-03-06</td>
            </tr>
            <tr>
              <td className="py-2">PAY-0002</td>
              <td className="py-2">Client B</td>
              <td className="py-2">2024-04-11</td>
            </tr>
            <tr>
              <td className="py-2">PAY-0003</td>
              <td className="py-2">Client C</td>
              <td className="py-2">2024-05-16</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
);

export default FinanceDashboard;
